import axios from "axios";
import { Brand } from "models/BO/Brand";
import { EmailTemplate } from "models/content/Comm";
import { refreshAuthDO } from "./authUtils";
import { logErrorWithContext } from "./coralogix";


export let networkGlobals = {
  brand: JSON.parse(window.localStorage.getItem("currentBrand") || "{}") as Brand,
  errorCallbacks: [] as Function[],
  serverHost: process.env.REACT_APP_SERVER_URL,
  langauge: "en",
};

const addQueryParams = (url: string, pname, pval) => {
  const param = new URLSearchParams(url.split("?")[1]);
  if (param.has(pname) && !!param.get(pname)) {
    return url;
  }
  param.set(pname, pval);
  const newUrl = url.split("?")[0] + "?" + param.toString();
  return newUrl;
}

// --- Actual makeRequest implementation ---
export async function baseMakeRequest(
  url,
  {
    method,
    body,
    auth = true,
    basePath,
    withoutError,
    brandId,
    withCredentials,
    params,
  }: {
    method?: string;
    body?: any;
    auth?: boolean;
    basePath?: string;
    withoutError?: boolean;
    brandId?: number;
    withCredentials?: boolean;
    params?: any;
  } = {}
) {
  url = addQueryParams(url, "brandID", brandId || networkGlobals.brand.id);
  url = addQueryParams(url, "lang", networkGlobals.langauge);
  if (params) {
    Object.entries(params)
      .filter(([key, value]) => value !== undefined)
      .forEach(([key, value]) => {
        url = addQueryParams(url, key, value);
      });
  }
  const headers = {
    // "X-env": networkGlobals.host,
    // "X-brand": brandId || networkGlobals.brand.id,
  };
  if (auth) {
    headers["Authorization"] = localStorage.getItem("BOToken");
  }

  return axios({
    method: method || "GET",
    url: (basePath || `${networkGlobals.serverHost}/api/`) + url,
    data: body,
    headers,
    withCredentials
  })
    .then((res) => {
      // No need to store refreshToken in localStorage anymore
      return res.data;
    })
    .catch((err) => {
      ;
      if (err.code == 'ERR_NETWORK') {
        networkGlobals.errorCallbacks.forEach((cb) =>  cb({message: "Server is updating... Please try again in a few minutes"}));
        return;
      }
      if (err.response) {
        const status = err.response.status || err.response.statusCode;
        if (status == 401) {
          localStorage.removeItem("BOToken");
          if (!localStorage.getItem("redirectAfterLogin")) {
            localStorage.setItem("redirectAfterLogin", window.location.href);
          }
          window.location.href = "#/sign-in";
          return;
        } else if (status == 403) {
          networkGlobals.errorCallbacks.forEach((cb) => cb({message: "Permission denied"}));
          return;
        } else if (status == 404) {
          networkGlobals.errorCallbacks.forEach((cb) => cb({message: "Not found"}));
          return;
        } else if (status == 409) {
          return err.response.data;
        } else if (status == 503) {
          networkGlobals.errorCallbacks.forEach((cb) =>
            cb({message: "Server is updating... Please try again in a few minutes"})
          );
          
          return;
        } else {
          logErrorWithContext("Server error", err, {
            url: url,
            method: method,
            body: body,
            status: err.response?.status,
            statusText: err.response?.statusText,
          }, "Network Request");
        }
      }
      if (!withoutError) {
        networkGlobals.errorCallbacks.forEach((cb) => cb(err));
        
      } else {
        throw err;
      }
    });
}


export async function makeRequest(url, options: {
  method?: string;
  body?: any;
  auth?: boolean;
  basePath?: string;
  withoutError?: boolean;
  brandId?: number;
  withCredentials?: boolean;
  params?: any;
}  = {}): Promise<any> {
  // Don't check/refresh for the refresh endpoint itself
  if (!["auth/refresh", "auth/", "brands"].includes(url)) {
   await refreshAuthDO();
  }
  return baseMakeRequest(url, options);
}

type RequestT = {
  method?: string;
  body?: any;
  auth?: boolean;
  basePath?: string;
  withoutError?: boolean;
  brandId?: number;
  url: string;
  time: number;
}

const pendingRequests:{[key:string]:RequestT} = {};

setInterval(() => {
  for (const key in pendingRequests) {
    const request = pendingRequests[key];
    if (request.time + 1000 < Date.now()) {
      const {url, ...r} = request;
      makeRequest(url, r);
      delete pendingRequests[key];
    }
  }},300);

export const cacheRequest = (
  url,
  request: {
    method?: string;
    body?: any;
    auth?: boolean;
    basePath?: string;
    withoutError?: boolean;
    brandId?: number;
  } = {}) => {
  const key = url + request.method;
  const r:RequestT = Object.assign({}, request) as RequestT;          
  r.url = url;
  r.time = Date.now();
  pendingRequests[key] = r;
};
  
export const getBucket = () => process.env.REACT_APP_BUCKET_NAME;

export const getChatBucket = () => process.env.REACT_APP_CHAT_BUCKET_NAME;

export const getLambadaSubdomain = () => process.env.REACT_APP_LAMBDA_SUBDOMAIN;

export const uploadImage = async (file: File, folder: string) => {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("folder", folder);
  return makeRequest("utils/images", {
    method: "POST",
    body: formData,
  });
};

export const fileLink = (url: string) => {
  return `${networkGlobals.serverHost}/api/utils/file?brandID=${networkGlobals.brand.id}&token=${localStorage.getItem("BOToken")}&url=${url}`;
};

export const getEmailTemplate = (template: EmailTemplate) => {
  return axios.get(
    `https://${getBucket()}.s3.us-east-1.amazonaws.com/public/sharedDocs/${
      networkGlobals.brand.folder
    }/en/emails/${template}.html`
  );
};

export const getCustomerSupportImage = (url: string, identityId: string) => {
  return fileLink(`https://${getChatBucket()}/private/${identityId}/${url}`);
};

export const extractOGTags = async (url: string) => {
  return makeRequest(`utils/extract-og-tags?url=${url}`);
};
